import { PalletConfig, PlacedPallet, LoadResult, TruckSpecs } from '../types';

// Simplified auto-packer for initial bulk calculation
export const calculateLoadPlan = (pallets: PalletConfig[], truckSpecs: TruckSpecs): LoadResult => {
  const placedPallets: PlacedPallet[] = [];
  let currentZ = 0;
  let currentX = 0;
  let rowMaxLength = 0;
  let totalWeight = 0;

  pallets.forEach(type => {
    for (let i = 0; i < type.quantity; i++) {
      const pWidth = type.width / 100; // cm to m
      const pLength = type.length / 100;
      const pHeight = type.height / 100;
      
      // Check if it fits in current row width
      if (currentX + pWidth <= truckSpecs.width) {
        placedPallets.push({
          id: `${type.id}-${i}`,
          configId: type.id,
          name: type.name,
          x: currentX + (pWidth / 2) - (truckSpecs.width / 2),
          y: pHeight / 2,
          z: currentZ + (pLength / 2) - (truckSpecs.length / 2),
          width: pWidth,
          length: pLength,
          height: pHeight,
          color: type.color,
          weight: type.weight,
          rotation: 0,
          stackable: type.stackable,
          maxStackWeight: type.maxStackWeight,
          stackedOn: null
        });
        
        currentX += pWidth;
        rowMaxLength = Math.max(rowMaxLength, pLength);
        totalWeight += type.weight;
      } else {
        // Start new row
        currentZ += rowMaxLength;
        currentX = 0;
        rowMaxLength = 0;

        // Check if fits in length
        if (currentZ + pLength <= truckSpecs.length) {
             placedPallets.push({
              id: `${type.id}-${i}`,
              configId: type.id,
              name: type.name,
              x: currentX + (pWidth / 2) - (truckSpecs.width / 2),
              y: pHeight / 2,
              z: currentZ + (pLength / 2) - (truckSpecs.length / 2),
              width: pWidth,
              length: pLength,
              height: pHeight,
              color: type.color,
              weight: type.weight,
              rotation: 0,
              stackable: type.stackable,
              maxStackWeight: type.maxStackWeight,
              stackedOn: null
            });
            currentX += pWidth;
            rowMaxLength = Math.max(rowMaxLength, pLength);
            totalWeight += type.weight;
        }
      }
    }
  });

  const usedLength = currentZ + rowMaxLength;

  return {
    placedPallets,
    totalWeight,
    usedLength,
    percentFull: (usedLength / truckSpecs.length) * 100,
    overweight: totalWeight > truckSpecs.maxWeight
  };
};

// Find the best position for a NEW single pallet without disturbing existing ones
export const findNextPosition = (
    newPallet: PalletConfig, 
    existingPallets: PlacedPallet[], 
    truckSpecs: TruckSpecs
): PlacedPallet[] => {
    
    const pWidth = newPallet.width / 100;
    const pLength = newPallet.length / 100;
    const pHeight = newPallet.height / 100;
    
    const newPlaced: PlacedPallet[] = [];
    
    // Simple naive placement: Find the furthest Z point used
    let startZ = 0;
    if (existingPallets.length > 0) {
        // Find max Z edge of existing pallets
        const maxZ = Math.max(...existingPallets.map(p => p.z + (p.length/2)));
        // Convert from center-relative to absolute (approx)
        startZ = maxZ + (truckSpecs.length/2);
    }

    // Try to pack the new quantity
    let currentX = 0;
    let currentZ = startZ;
    let rowMaxL = 0;

    for(let i=0; i<newPallet.quantity; i++) {
        // Wrap if X is full
        if (currentX + pWidth > truckSpecs.width) {
            currentZ += rowMaxL;
            currentX = 0;
            rowMaxL = 0;
        }
        
        // If Z is full, we just place it sticking out (user will see it and move it) or stop
        // For UX, let's place it.
        
        newPlaced.push({
            id: `${newPallet.id}-${Date.now()}-${i}`,
            configId: newPallet.id,
            name: newPallet.name,
            x: currentX + (pWidth / 2) - (truckSpecs.width / 2),
            y: pHeight / 2,
            z: currentZ + (pLength / 2) - (truckSpecs.length / 2),
            width: pWidth,
            length: pLength,
            height: pHeight,
            color: newPallet.color,
            weight: newPallet.weight,
            rotation: 0,
            stackable: newPallet.stackable,
            maxStackWeight: newPallet.maxStackWeight,
            stackedOn: null
        });

        currentX += pWidth;
        rowMaxL = Math.max(rowMaxL, pLength);
    }
    
    return newPlaced;
};